/**
 * Curated explainer content for Normies Studio Explainer mode.
 *
 * Each topic generates a single educational slide.
 * All copy is verified and static — no API calls needed.
 */

export const EXPLAINER_TOPICS = [
  {
    id: 'what-is-normie',
    title: 'WHAT IS A NORMIE?',
    kicker: 'THE BASICS',
    subtitle: '10,000 on-chain pixel characters on Ethereum',
    body: 'Normies are 40×40 pixel avatars stored entirely on-chain. Each one is unique, customizable through the Canvas system, and can be Awakened into an AI agent via ERC-8004.',
    tags: ['NFT', 'ETHEREUM', 'ON-CHAIN', '40×40'],
  },
  {
    id: 'what-is-canvas',
    title: 'WHAT IS CANVAS?',
    kicker: 'CUSTOMIZATION',
    subtitle: 'Edit your Normie pixel by pixel — on-chain',
    body: 'Canvas lets you modify your Normie\'s appearance directly on the blockchain. Every pixel edit is recorded, tracked, and permanent. Your Normie evolves with each change.',
    tags: ['CANVAS', 'ON-CHAIN', 'PIXELS', 'CUSTOMIZATION'],
  },
  {
    id: 'what-is-awakening',
    title: 'WHAT IS AWAKENING?',
    kicker: 'ERC-8004',
    subtitle: 'Turn your Normie into a living AI agent',
    body: 'Awakening binds an AI persona to your Normie via the ERC-8004 standard. Your agent gets a name, personality, backstory, and can interact with the world autonomously.',
    tags: ['ERC-8004', 'AGENT', 'AI', 'AWAKENED'],
  },
  {
    id: 'what-is-erc8004',
    title: 'WHAT IS ERC-8004?',
    kicker: 'THE STANDARD',
    subtitle: 'The token standard for on-chain AI agents',
    body: 'ERC-8004 is a new Ethereum standard that enables NFTs to carry AI agent bindings. It defines how personality, memory, and behavior attach to tokens on-chain.',
    tags: ['ERC-8004', 'ETHEREUM', 'STANDARD', 'AI'],
  },
  {
    id: 'what-is-bitmap',
    title: '40×40 ON-CHAIN BITMAP',
    kicker: 'THE FORMAT',
    subtitle: '1,600 pixels. Fully on-chain. Fully yours.',
    body: 'Each Normie is a 40×40 grid of pixels stored directly in the smart contract. No IPFS. No external server. Pure on-chain art that exists as long as Ethereum does.',
    tags: ['ON-CHAIN', 'BITMAP', '40×40', 'PERMANENT'],
  },
  {
    id: 'what-is-burn',
    title: 'WHAT IS BURNING?',
    kicker: 'DESTRUCTION',
    subtitle: 'Permanently destroy a Normie — reduce supply forever',
    body: 'Burning sends a Normie to the zero address, permanently removing it from circulation. The burned image is preserved as a memorial, but the token can never be recovered.',
    tags: ['BURN', 'DEFLATIONARY', 'PERMANENT'],
  },
];

export const EXPLAINER_TOPIC_MAP = Object.fromEntries(
  EXPLAINER_TOPICS.map(t => [t.id, t])
);

export const DEFAULT_EXPLAINER_TOPIC = 'what-is-normie';
